import { Field } from 'formik';
import React from 'react';
import { Link } from 'react-router-dom';
import { Input, Tooltip } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { useMetaConversionPixel } from '../../../../../Apps/pages/AppsMetaConversions';
export const FacebookPixelField = () => {
    const { pixelId, isLoading, error } = useMetaConversionPixel();
    if (isLoading)
        return React.createElement(Input, { disabled: true });
    if (error)
        return React.createElement(Input, { disabled: true, label: error.message });
    if (!pixelId)
        return (React.createElement(Field, { component: Input, name: "facebookPixelId", label: "Facebook Pixel ID", suggestion: React.createElement("div", null,
                "We recommend using the Meta Conversions API. Set it up in the",
                ' ',
                React.createElement(Link, { to: routing.apps.metaCAPI }, "Meta Ads App"),
                ".") }));
    return (React.createElement(Tooltip, { offset: [0, 8], placement: "bottom-start", reference: React.createElement(Input, { label: "Facebook Pixel ID (Conversions API)", value: pixelId, type: "text", disabled: true }) },
        React.createElement("div", null, "You are using the Meta Conversions API through the Meta Ads App. Your shop will use the pixel id set through that app.")));
};
